import Nav from "./Nav";
import NavNew from "./NavNew";
import NavLatest from './NavLatest';

//header
const Header = ({ items, headerlogo }) => {
    return(
      <header className="header">
        {/* <Nav items={items} headerlogo={headerlogo}></Nav> */}
        {/* <NavNew items={items} headerlogo={headerlogo}></NavNew> */}
        <NavLatest items={items} headerlogo={headerlogo}></NavLatest>
      </header>
    );
}
  
export default Header;